// src/components/ui/LoadingSkeleton.js
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Card, CardHeader, CardContent } from './Card';

const Skeleton = ({ className, ...props }) => {
  return <div className={twMerge('animate-pulse rounded-md bg-gray-800', className)} {...props} />;
};

export const PlayerCardSkeleton = () => (
  <Card variant="default" className="overflow-hidden">
    <div className="aspect-square bg-gray-800"></div>
    <div className="p-4">
      <Skeleton className="h-4 w-16 mb-2" />
      <Skeleton className="h-6 mb-2" />
      <Skeleton className="h-3 w-20" />
    </div>
  </Card>
);

export const StatCardSkeleton = () => (
  <Card variant="default" className="overflow-hidden">
    <div className="p-4">
      <div className="flex items-center mb-4">
        <Skeleton className="h-12 w-12 rounded-full mr-3" />
        <div className="flex-1">
          <Skeleton className="h-5 w-32 mb-2" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Skeleton className="h-8" />
        <Skeleton className="h-8" />
        <Skeleton className="h-8" />
      </div>
    </div>
  </Card>
);

export const TableRowSkeleton = ({ columns = 4 }) => (
  <tr>
    {Array(columns)
      .fill(0)
      .map((_, i) => (
        <td key={i} className="px-4 py-2">
          <Skeleton className="h-4" />
        </td>
      ))}
  </tr>
);

export const ContentCardSkeleton = () => (
  <Card variant="default">
    <CardHeader>
      <Skeleton className="h-6 w-3/4 mb-2" />
      <Skeleton className="h-4 w-1/2" />
    </CardHeader>
    <CardContent>
      <Skeleton className="h-24 mb-4" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>
    </CardContent>
  </Card>
);

export const HighlightCardSkeleton = () => (
  <Card variant="glass">
    <div className="p-4">
      <Skeleton className="h-5 w-1/3 mb-4" />
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-11/12" />
        <Skeleton className="h-4 w-4/5" />
      </div>
    </div>
  </Card>
);

export const GridSkeleton = ({ count = 6, children }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array(count)
      .fill(0)
      .map((_, i) => (
        <React.Fragment key={i}>{children}</React.Fragment>
      ))}
  </div>
);

export const ListSkeleton = ({ count = 4, children }) => (
  <div className="space-y-4">
    {Array(count)
      .fill(0)
      .map((_, i) => (
        <React.Fragment key={i}>{children}</React.Fragment>
      ))}
  </div>
);
